import { buildSseUrl } from "@/config/endpoints";

export const SSE_RECONNECT_INTERVAL_MS = 3000;

export interface SseUser {
  id: string | number;
  key: string;
}

interface SseMonitorOptions {
  getClient: () => EventSource | null;
  setClient: (client: EventSource | null) => void;
  hasEvents: () => boolean;
  setupStream: () => void;
  intervalMs?: number;
}

type SseEventHandler = (event: MessageEvent) => void;

export function createSseClient(userType: number, user: SseUser | null | undefined): EventSource | null {
  if (!user) {
    return null;
  }

  return new EventSource(buildSseUrl(userType, user.id, user.key));
}

export function addSseEventListeners(client: EventSource, handlers: Record<string, SseEventHandler>): void {
  Object.entries(handlers).forEach(([eventName, handler]) => {
    client.addEventListener(eventName, handler as EventListener, { passive: true });
  });
}

export function parseSseJsonEvent<T = unknown>(event: MessageEvent): T {
  return JSON.parse(event.data) as T;
}

export function closeSseClient(client: EventSource | null | undefined): void {
  if (!client) {
    return;
  }

  try {
    client.close();
  } catch (err) {
    console.error(err);
  }
}

export function startSseMonitor(options: SseMonitorOptions): number {
  const intervalMs = options.intervalMs ?? SSE_RECONNECT_INTERVAL_MS;

  return window.setInterval(() => {
    const client = options.getClient();

    if (EventSource.OPEN !== client?.readyState || !options.hasEvents()) {
      closeSseClient(client);
      options.setClient(null);
      options.setupStream();
    }
  }, intervalMs);
}

export function stopSseMonitor(verifier: number | null | undefined): void {
  if (verifier) {
    clearInterval(verifier);
  }
}
